import { Select } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/store";
import SelectDownIcon from "../../assets/icons/SelectDownIcon";
import { useGetAppliedJobQuery } from "../../features/employee/employeeApi";
import useError from "../../hooks/useError";
import { TJobSwitchTab } from "../../pages/admin/JobPost/ViewJob";
import { GetAppliedJobParamsType, JobPostDetail } from "../../types";
import { selectSearchOption } from "../../utils/utils";
import ApplicationList, { applicationStatusList } from "./ApplicationList";
import JobDetailsView from "./JobDetailsView";
import JobSwitchTab from "./JobSwitchTab";

type Props = {
  data?: JobPostDetail;
};

type Status = GetAppliedJobParamsType["status"];

export default function JobListAndApplied({ data }: Props) {
  const { id } = useParams();
  const [tab, setTab] = useState<TJobSwitchTab>("DETAILS");
  const { authInfo } = useAppSelector((state) => state.auth);
  const [status, setStatus] = useState<Status>(undefined);
  const {
    isLoading,
    isError,
    error,
    data: appliedData,
  } = useGetAppliedJobQuery({
    params: {
      business_id: Number(authInfo?.business_id),
      job_post_id: Number(id),
      skip: 0,
      limit: 0,
      status,
    },
  });
  useError(isError, error, "Get job applied data fail");

  return (
    <div className="p-4 bg-white rounded-md border border-extra-light mt-6">
      <JobSwitchTab
        tab={tab}
        setTab={setTab}
        applicant={appliedData?.data?.totalLength}
      >
        {tab === "APPLICANT" && (
          <Select
            allowClear
            showSearch
            placeholder="Status"
            options={Object.entries(applicationStatusList).map(
              ([key, value]) => ({
                label: value.value,
                value: key,
              })
            )}
            onChange={(val) => setStatus(val)}
            filterOption={selectSearchOption}
            className="min-w-[120px]"
            suffixIcon={<SelectDownIcon />}
            rootClassName="icon-gray"
            popupMatchSelectWidth={120}
          />
        )}
      </JobSwitchTab>

      {tab === "APPLICANT" ? (
        <ApplicationList
          loading={isLoading}
          data={appliedData?.data?.applications}
        />
      ) : (
        <JobDetailsView data={data} />
      )}
    </div>
  );
}
